import {WalletDispatch, WalletState} from "./index";
import {useDispatch, TypedUseSelectorHook, useSelector} from "react-redux";

type DispatchFunc = () => WalletDispatch;
export const useWalletDispatch: DispatchFunc = useDispatch;
export const useWalletSelector: TypedUseSelectorHook<WalletState> = useSelector;
